import { unitToString } from './registry';
import { Unit } from './types';
import { UnitError } from './UnitError';

export class NoConversionError extends UnitError {
  readonly name = 'NoConversionError';
  constructor(from: Unit, to: Unit) {
    super(
      `Unable to convert from "${unitToString(from)}" to "${unitToString(to)}"`
    );
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, NoConversionError);
    }
    Object.setPrototypeOf(this, NoConversionError.prototype);
  }
  static invariant: (b: boolean, from: Unit, to: Unit) => asserts b = (
    b,
    from,
    to
  ) => {
    if (!b) {
      throw new NoConversionError(from, to);
    }
  };
}
